import React from 'react';
import VersionDetailNavbar from '../VersionDetailNavbar';
import VersionDetailInfo from '../versionDetail/VersionDetailInfo';
import VersionDetailType from '../versionDetail/VersionDetailType';
import './VersionDetailWrap.scss';

const VersionDetailWrap = (props) => {
  const { onSubmit, deleteVersion, isEditable, form, setData, versionDetail, pageType } = props;

  return (
    <div className="version-detail-wrap">
      {/* 하단 네브바 (저장, 삭제) */}
      <VersionDetailNavbar onSubmit={onSubmit} deleteVersion={deleteVersion} />

      {/* 타입 */}
      <VersionDetailType pageType={pageType} form={form} setData={setData} data={versionDetail.verType} />

      {/* 서비스 정보 */}
      <VersionDetailInfo isEditable={isEditable} form={form} setData={setData} data={versionDetail.verInfo} />
    </div>
  );
};

export default VersionDetailWrap;
